import { Injectable } from '@angular/core';

import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationSSO } from './configuration-sso.model';

@Injectable({
	providedIn: 'root'
})
export class SsoConfigurationService {

	url: string = '/ws/sso';
	urlConfiguration: string = `${this.url}/configuration`;

	configurationSsoCourante: ConfigurationSSO;

	private httpBackend: HttpClient;

	constructor(httpBackend: HttpBackend) {
		this.httpBackend = new HttpClient(httpBackend);
	}

	/**
	 * Récupére les configurations du sso depuis le serveur
	 */
	chargerConfigurationOauth2(apiUrl: string = ''): Observable<ConfigurationSSO> {
		return this.httpBackend.get<ConfigurationSSO>(apiUrl + this.urlConfiguration);
	}

	/**
	 * Détermine si le Sso est actif
	 * @return true si le sso est actif
	 */
	ssoActif(): boolean {
		return this.configurationSsoCourante?.actif;
	}

	/**
	 * Récupère l'url de connexion sigale pour le sso
	 */
	get urlConnectionSigale() : string {
		return `${this.configurationSsoCourante?.apiUrl ?? ''}${this.url}/connexion`;
	}
}
